export default "__VITE_ASSET__DRZHI3B$__"